export class AppSettings {
   public static API_ENDPOINT    = 'https://pakistansweethome.org.pk/portal/';
   public static IMG_ENDPOINT    = 'https://pakistansweethome.org.pk/portal/';
   public static BACK_ENDPOINT    = 'https://adminbackend.pakistansweethome.org.pk/api/';
   // public static PDF_ENDPOINT    = 'https://paymentplans.skyparkone.com/';
}
